module.exports = __webpack_public_path__ + "img/signup-carousel-sixth.e31dc909.png";